export default __webpack_public_path__ + "static/media/sec.24044d81.png";